import { createMuiTheme, Theme } from '@material-ui/core/styles';
import { createStyles, makeStyles } from '@material-ui/styles';


const defaultTheme = createMuiTheme();
export const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        border: 0,
        color:
          theme.palette.type === 'light' ? '#000000' : 'rgba(255,255,255,0.85)',
        letterSpacing: 'normal',
        '& .MuiDataGrid-columnsContainer': {
          backgroundColor:
            theme.palette.type === 'light' ? '#fafafa' : '#1d1d1d',
        },
        '& .MuiDataGrid-iconSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-columnHeader': {
          padding: '0 2px',
        },
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 'bold',
        },
        '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
          borderLeft: `1px solid ${
            theme.palette.type === 'light' ? '#dddddd' : '#303030'
          }`,
        },
        '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
          borderBottom: `1px solid ${
            theme.palette.type === 'light' ? '#dddddd' : '#303030'
          }`,
        },
        '& .MuiDataGrid-row.Mui-selected': {
          backgroundColor: '#ffffff',
        },
        '& .MuiDataGrid-row.Mui-selected:hover': {
          backgroundColor: 'rgba(200, 200, 200, 0.12)',
        },
        '& .MuiDataGrid-cell': {
          color:
            theme.palette.type === 'light'
              ? 'rgba(0,0,0,.85)'
              : 'rgba(255,255,255,0.65)',
        },
        '& .MuiDataGrid-cell:focus': {
          outline: 0,
        },
        '& .MuiDataGrid-editInputCell input': {
          color: '#000000',
        },
        '& .MuiPaginationItem-root': {
          borderRadius: 0,
        },
      },
    }),
  { defaultTheme },
);